// ** Components
import Content from './Content';
import Article from './Article';
import Homepage from './Homepage';

// ** Types
import type { ComponentType } from 'react';
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksHero as BlocksHeroProps } from '@/types/graphql';

type ComponentBlocksHeroProps = Partial<StrapiComponentProps<BlocksHeroProps>> & {
	newsBasePath?: string | null;
	eventsBasePath?: string | null;
	userBasePath?: string | null;
	segmentOverrides?: string[];
};

const ComponentBlocksHero = (props: ComponentBlocksHeroProps) => {
	const { heroVariant } = props;

	// Type components strictly using ComponentType<ComponentBlocksHeroProps>
	const variantComponents: Record<string, ComponentType<ComponentBlocksHeroProps>> = {
		Content: Content as ComponentType<ComponentBlocksHeroProps>,
		Article: Article as ComponentType<ComponentBlocksHeroProps>,
		Homepage: Homepage as ComponentType<ComponentBlocksHeroProps>
	};

	// Fallback logic
	const SelectedComponent =
		(heroVariant && variantComponents[heroVariant]) || (Content as ComponentType<ComponentBlocksHeroProps>);

	return <SelectedComponent {...props} />;
};

export default ComponentBlocksHero;
